import React, { useState, useRef } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import SecurityBeneficersComponent from '../../components/profile/SecurityBeneficersComponent'
import UserMenuComponent from '../../components/profile/UserMenuComponent';
const SecurityBeneficers = props => {
  //*States
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  //*Ref
  const childRef = useRef();
  
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">{ props.match.params.name }
              <ButtonGroup>
                <Button
                  onClick={props.history.goBack}
                  size="sm"><i className="material-icons">keyboard_return</i></Button>
              <UserMenuComponent id={props.match.params.id} name={props.match.params.name} type={props.match.params.type} /> 
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => childRef.current.onAdd()}><i className="material-icons">add</i></Button>
              </ButtonGroup>
            </h2>
            <hr />
            <h6>Beneficiarios</h6>
          </div>
          <SecurityBeneficersComponent ref={childRef} type={props.match.params.type} id={props.match.params.id} />
        </div>
      </div>
    </>
  )
}

export default withRouter(SecurityBeneficers)
